import { validateForUI } from 'common/helpers/jsonValidator';

const passwordSchema = {
  type: 'object',
  properties: {
    password: { type: 'string', minLength: 8 },
    confirmPassword: { type: 'string', minLength: 8 }
  },
  required: ['password', 'confirmPassword'],
  additionalProperties: false
};

export const validatePassword = (password) => {
  const errors = validateForUI(
    passwordSchema,
    password,
    customPasswordValidate(password)
  );
  return errors;
};

const customPasswordValidate = (customer) => {
  const errorArray = [];
  if (customer.password !== customer.confirmPassword) {
    const error = {
      field: 'confirmPassword',
      message: 'Confirm Password must match Password'
    };
    errorArray.push(error);
  }
  return errorArray;
};
